module.exports = __webpack_public_path__ + "img/moolsnetlogo.4b43c736.png";